// React
import React, { Component } from "react";
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";
import { compose } from "redux";
// Form
import { Field, reduxForm } from "redux-form";
// i18n
import { withNamespaces } from "react-i18next";
// Router
import { replace } from "react-router-redux";
import { BASE_URL } from "../../config/constants";

// Validators
import {
  required,
  digits,
  maxLength,
  minLength,
  uppercase,
  allowedSymbols,
  forbiddenSymbols
} from "../../services/validators";
// Ducks
import { changePassword } from "./PasswordChange.ducks";
import { setNotification } from "../../components/SmartNotification/SmartNotification.ducks";
// Components
import Form from "../../components/Form";
import Input from "../../components/Input";

class PasswordChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordsMatch: true
    };
    this.validateProp = [required];
  }

  componentWillMount() {
    const {
      replace,
      auth: {
        profile: { isPasswordIntendedToChange }
      }
    } = this.props;
    !isPasswordIntendedToChange && replace(`${BASE_URL}/one_time_profile`);
  }

  componentDidMount() {
    const {
      auth: {
        profile: { passwordPolicy }
      }
    } = this.props;
    if (!passwordPolicy) {
      localStorage.clear();
      replace(`${BASE_URL}`);
    }
    this.initProps();
  }

  initProps = () => {
    const {
      auth: {
        profile: { passwordPolicy }
      },
      t
    } = this.props;

    // if the passwordPolicy doesn't exist, clear the local storage and send the user back to the login page

    if (passwordPolicy) {
      if (passwordPolicy.minLength) {
        const minLengthValid = minLength(
          passwordPolicy.minLength,
          t(`modules.localization.register.authenticated.passwordChange.minLength`, {
            min: passwordPolicy.minLength
          })
        );
        this.validateProp.push(minLengthValid);
      }

      if (passwordPolicy.maxLength) {
        const maxLengthValid = maxLength(
          passwordPolicy.maxLength,
          t(`modules.localization.register.authenticated.passwordChange.maxLength`, {
            max: passwordPolicy.maxLength
          })
        );
        this.validateProp.push(maxLengthValid);
      }

      if (passwordPolicy.needUppercaseCharacters) {
        const uppercaseValid = uppercase(
          t(`modules.localization.register.authenticated.passwordChange.uppercase`)
        );
        this.validateProp.push(uppercaseValid);
      }

      if (passwordPolicy.needNumericCharacters) {
        const digitsValid = digits(
          t(`modules.localization.register.authenticated.passwordChange.digits`)
        );
        this.validateProp.push(digitsValid);
      }

      if (passwordPolicy.needSpecialCharacters) {
        const symbols = passwordPolicy.allowedSpecialCharacters || `all`;
        const symbolsValid = allowedSymbols(
          symbols,
          t(`modules.localization.register.authenticated.passwordChange.symbols`)
        );
        this.validateProp.push(symbolsValid);

        const forbiddenCharacters = passwordPolicy.forbiddenSpecialCharacters || `none`;
        const forbiddenSymbolsValid = forbiddenSymbols(
          forbiddenCharacters,
          t(`modules.localization.register.authenticated.passwordChange.forbiddenSymbols`, {
            forbidden: passwordPolicy.forbiddenSpecialCharacters
          })
        );
        this.validateProp.push(forbiddenSymbolsValid);
      }
    }
  };

  onSubmit = (values) => {
    const { changePassword } = this.props;
    if (values.password1 !== values.password2) {
      this.setState({
        passwordsMatch: false
      });
    } else {
      changePassword(values.password1);
    }
  };

  showNotification = () => {
    const { setNotification } = this.props;

    setNotification({
      messageTranslationKey: `modules.localization.register.authenticated.passwordChange.passwordsDontMatch`,
      titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`,
      type: `error`
    });
  };

  render() {
    const { handleSubmit, t, valid } = this.props;
    const { passwordsMatch } = this.state;

    if (!passwordsMatch) {
      this.showNotification();
    }

    return (
      <div className="container">
        <Form
          bootStrapClass="col-sm-6 col-sm-offset-3 no-padding well"
          buttonDisabled={!valid}
          handleSubmit={handleSubmit}
          onSubmit={this.onSubmit}
          title={t(
            `modules.localization.register.authenticated.passwordChange.firstTimeChangePassword`
          )}
        >
          <fieldset>
            <Field
              component={Input}
              iconClass="icon-append fa fa-lock"
              label={t(`modules.localization.register.authenticated.passwordChange.label.password`)}
              name="password1"
              type="password"
              validate={this.validateProp}
            />
            <Field
              component={Input}
              iconClass="icon-append fa fa-lock"
              label={t(
                `modules.localization.register.authenticated.passwordChange.label.repeatPassword`
              )}
              name="password2"
              type="password"
              validate={this.validateProp}
            />
          </fieldset>
        </Form>
      </div>
    );
  }
}

PasswordChange.propTypes = {
  auth: PropTypes.object,
  changePassword: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  replace: PropTypes.func,
  setNotification: PropTypes.func,
  t: PropTypes.func.isRequired,
  valid: PropTypes.bool
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

const mapDispatchToProps = { changePassword, replace, setNotification };

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    form: `passwordChange`
  }),
  withNamespaces()
)(PasswordChange);
